"use strict";

exports.__esModule = true;
exports.UPDATE_LOCALE = void 0;
const UPDATE_LOCALE = 'locale.UPDATE_LOCALE';
exports.UPDATE_LOCALE = UPDATE_LOCALE;